import SignsListPageContainer from './containers/SignsListPageContainer'

export default SignsListPageContainer
